import { useFormikContext } from "formik";
import { Company, Industry } from "models/Company";
import IndustriesCustomer from "./Industries/IndustriesCustomer";
import IndustriesNonCustomer from "./Industries/IndustriesNonCustomer";
import { Seo } from "components/Seo";


const Industries = () => {

    const { values, setFieldValue, handleChange } = useFormikContext<Company>();

    return (
        <><Seo title="Bransjer" />
            <div className="mb-4">
                <label htmlFor="Hovedbransje" className="form-label">Hovedbransje</label>
                <select className="form-select" id="Hovedbransje" disabled={values.industries.length <= 1} name="mainIndustryCode" onChange={(event: { target: { value: string }; }) => {
                    setFieldValue(`mainIndustryCode`, event.target.value);

                    let mainIndustryIndex = values.industries.findIndex(x => x.id === event.target.value);

                    if (mainIndustryIndex !== -1){
                        setFieldValue(`industries.[${mainIndustryIndex}].code`, event.target.value);
                        setFieldValue(`industries.[${mainIndustryIndex}].isMain`, true);

                        values.industries.forEach((ind : Industry, index : Number) => {
                            if (index !== mainIndustryIndex){
                                setFieldValue(`industries.[${index}].isMain`, false);
                            }
                        })

                    }

                    handleChange(event);
                }}>
                    
                    { values.industries.length >= 1 ? values.industries.map((industry, index) => 
                            !industry.deleted
                            ? <option value={industry.code} key={index}>{industry.name}</option> 
                            : null
                    ) : <option>Ingen hovedbransje valgt</option>}
                </select>

            </div>
            {values.hasProducts ?
                <IndustriesCustomer companyName={values.name} industries={values.industries}></IndustriesCustomer> :
                <IndustriesNonCustomer></IndustriesNonCustomer>}
        </>

    )
}

export default Industries